/**
 * UNDO THIS — one request's edits, taken back (spec section 3, Q17). A point remembers the unsaved edits
 * before and after the request, as JSON. It is offered only while the unsaved edits are EXACTLY as the
 * request left them: a later form edit, another request, or a save (which closes the editor) removes it,
 * so Undo only ever removes the chat's own work. It never undoes a save or a held action.
 */
import type { Entity } from '../../../../model/entity.model';

export interface UndoPoint {
  requestId: string;
  /** JSON of the unsaved edits before the request; 'null' when no entity was open (a create). */
  before: string;
  after: string;
}

export function undoPoint(requestId: string, before: Entity | null, after: Entity): UndoPoint {
  return { requestId, before: JSON.stringify(before), after: JSON.stringify(after) };
}

export function canUndo(point: UndoPoint | null, current: Entity | null): boolean {
  return !!point && !!current && JSON.stringify(current) === point.after;
}

/** The unsaved edits to restore; null = close the entity the request created. */
export function undoTo(point: UndoPoint): Entity | null {
  return JSON.parse(point.before) as Entity | null;
}
